import DuplicateForeCast from '../../../../components/AssetManagement/Overview/PerformanceForecaster/DuplicateForeCast/DuplicateForeCast'

const DuplicateForecastScreen = () => {
  return (
    <>
      <DuplicateForeCast />
    </>
  )
}

export default DuplicateForecastScreen
